import { Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Box, propNames } from "@chakra-ui/react";
import PlantListItem, { PlantListItemProps } from "../PlantListItem";

export interface PlantListProps {
    items: PlantListObject[];
};

export interface PlantListObject {
    itemName: string;
    plantListItem: PlantListItemProps;
}

const PlantListElement = (props: PlantListProps) => {
    return (
        <Accordion
            allowMultiple
        >
            { props.items.map((item) => 
                <AccordionItem>
                    <h2>
                        <AccordionButton>
                            <Box flex='1' textAlign='left'>
                                { item.itemName }
                            </Box>
                            <AccordionIcon />
                        </AccordionButton>
                    </h2>
                    <AccordionPanel>
                        <PlantListItem 
                            content={ item.plantListItem.content } 
                            image={ item.plantListItem.image }
                            footerContent={ item.plantListItem.footerContent }
                        />
                    </AccordionPanel>
                </AccordionItem>
            )
            }
        </Accordion>
    );
};

export default PlantListElement;